import { p as presets } from "../presets.js";
const getColorDefaultConfig = () => ({
  variables: presets.light,
  threshold: 150,
  presets: {
    light: presets.light,
    dark: presets.dark
  },
  currentPresetName: "light"
});
export { getColorDefaultConfig as g };
//# sourceMappingURL=default.js.map
